import React from 'react'

export const HelpButton = ({ onPress }: { onPress: () => void }) => (
  <button style={{ padding: 8, marginLeft: 4 }} onClick={onPress}>
    Help &amp; Feedback
  </button>
)
